import React from 'react'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import StateTerritoryForm from '../../../../accs/form/state-territory'


const formValue = 'update_state_territory'

const available = (record) =>
  hasAvailableAction(record, 'update_state_territory')

const calculateSubmitValues = (values) => {
  const submitValues = { ...values }

  if (values.evidence && values.evidence.length > 0) {
    submitValues.evidence = values.evidence[0]
    submitValues.evidence.type = 'ACC003'
  }

  return submitValues
}

export const defaultValues = () => ({
  evidence: [],
  is_declaration_given: false,
  state_details: {
    first_name: '',
    last_name: '',
    additional_infor: '',
    date_of_notice: null,
    org_name: '',
    body_type: 'CODE01',
    ref_number: '',
    person_id: '',
    person_phone: '',
    person_email: '',
    notified_third_party: false,
    third_party_notified_me: false,
  },
})

const actionForm = ({ regHolderId, record }) => ({ handleSuccess }) => {
  const certificateID = record.gov_record.certificateID

  return (
    <DefaultForm
      url={
        process.env.REACT_APP_API_HOST +
        `/api/services/${regHolderId}/accs/certificate/${certificateID}/update`
      }
      name={formValue}
      label="Update Certificate"
      calculateSubmitValues={calculateSubmitValues}
      handleSuccess={() =>
        handleSuccess({ [formValue]: 'State & Territory updated.' }, formValue)
      }
      formOptions={{ defaultValues: defaultValues(record) }}
      formComponent={(props) => (
        <StateTerritoryForm {...props} required={true} c />
      )}
    />
  )
}

export const stateTerritory = ({
  regHolderId,
  child,
  record,
  refresh_accs_gov_enrolments,
}) => {
  return available(record)
    ? {
      label: 'Update State & Territory',
      value: 'update_state_territory',
      actionForm: actionForm({ record, regHolderId, child }),
      onCompletePreserveAction: true,
      onComplete: refresh_accs_gov_enrolments,
    }
    : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/update-state-territory/index.js